import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import Layout from '../components/layout/Layout';
import { ROUTES } from '../constants/routes';

// Pages
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import DashboardPage from '../pages/DashboardPage';
import AdminPage from '../pages/AdminPage';
import PropertySearchPage from '../pages/PropertySearchPage';
import EmailVerificationPage from '../pages/EmailVerificationPage';

/**
 * AppRoutes component
 * Defines all application routes with authentication guards
 */
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Layout wrapper for all routes */}
      <Route element={<Layout />}>
        {/* Public routes - accessible when NOT authenticated */}
        <Route element={<PublicRoute />}>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />
          <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
        </Route>

        {/* Routes accessible to all */}
        <Route path={ROUTES.PROPERTY_SEARCH} element={<PropertySearchPage />} />
        <Route path={ROUTES.EMAIL_VERIFICATION} element={<EmailVerificationPage />} />

        {/* Protected routes - require authentication */}
        <Route element={<ProtectedRoute />}>
          <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
        </Route>

        {/* Admin routes - require admin privileges */}
        <Route element={<ProtectedRoute requireAdmin />}>
          <Route path={ROUTES.ADMIN} element={<AdminPage />} />
        </Route>

        {/* Catch-all redirect to home */}
        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
